import EA from '../helpers/init';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default EA.Methods.logoChange = ($this) => {
    const darkSections = document.querySelectorAll('.bg-dark');

    ScrollTrigger.matchMedia({
        '(max-width: 1000px)': function () {
            darkSections.forEach((section) => {
                ScrollTrigger.create({
                    trigger: section,
                    start: 'top 10%',
                    end: 'bottom 10%',
                    toggleClass: { targets: '.site-logo', className: 'logo-white-active' },
                    markers: false
                });
            });
        }
    });
};
